/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import {
  LABEL_INVALID_EMAIL,
  LABEL_RECOVERY_HELP,
  LABEL_FIRSTNAME,
  LABEL_LASTNAME,
  LABEL_LOGIN,
  LABEL_FIELD_NOT_CONTAIN,
  LABEL_FIELD_BETWEEN,
  LABEL_PWD_HELP,
  LABEL_FIELD_INVALID,
  LABEL_EMAIL,
  LABEL_PASSWORD,
  LABEL_USERNAME_ALREADY_EXISTS,
  LABEL_USERNAME_INVALID,
  LABEL_INTERNAL_DOMAIN,
  LABEL_PASSWORD_STRONGER,
  LABEL_PASSWORD_DONT_MATCH,
} from './i18nLabels';

export interface FormLabelParam {
  label: string;
}

export interface FormLabel {
  label?: string;
  params?: Array<string | number | FormLabelParam>;
}

export {
  LABEL_INVALID_EMAIL,
  LABEL_RECOVERY_HELP,
  LABEL_FIRSTNAME,
  LABEL_LASTNAME,
  LABEL_LOGIN,
  LABEL_FIELD_NOT_CONTAIN,
  LABEL_FIELD_BETWEEN,
  LABEL_PWD_HELP,
  LABEL_FIELD_INVALID,
  LABEL_EMAIL,
  LABEL_PASSWORD,
  LABEL_USERNAME_ALREADY_EXISTS,
  LABEL_USERNAME_INVALID,
  LABEL_INTERNAL_DOMAIN,
  LABEL_PASSWORD_STRONGER,
  LABEL_PASSWORD_DONT_MATCH,
};

export function translateFormLabel(formLabel: FormLabel, $t: any) {
  const { label } = formLabel;
  let params;

  if (formLabel.params) {
    params = [];
    for (let i = 0; i < formLabel.params.length; i += 1) {
      const param = formLabel.params[i] as any;
      if (param.label) {
        params.push($t(param.label).toString());
      } else {
        params.push(param);
      }
    }
  }

  return $t(label as any, params as any);
}
